<template lang="pug">
  v-tabs.tabs(
    v-model='tab',
    light,
    vertical,
    icons-and-text,
    hide-slider,
  )
    v-tab.mb-5(
      v-for="tab in list",
      active-class="primary",
      :key="tab.text",
      :to="getRoute(tab.route)",
    )
      | {{ tab.text }}
      v-icon fas {{ tab.icon }}

    v-tab-item(:value="$route.fullPath")
      v-card(flat)
        v-card-text.pt-0
          slot
</template>

<script>
import { map, has, propOr, mergeRight } from 'ramda';
import { roleManager } from '@/config/mixins';
import * as tabs from '@/constant/tab';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },

    tabArg: {
      type: Object,
      default: () => {},
    },
  },

  mixins: [roleManager],

  data() {
    return {
      tab: null,
    };
  },

  computed: {
    list() {
      const tabDisplay = this.$t(`tab.${this.type}`);
      return map(tab => {
        const text = tab.value !== '' ? tabDisplay[tab.value] : '';

        return mergeRight(tab, { text });
      }, tabs[this.type](this.tabArg)).filter(tab => {
        return !tab.permission || tab.permission.includes(this.authUser.role);
      });
    },
  },

  methods: {
    getRoute(route) {
      if (!route) {
        return null;
      }

      if (has('key', route)) {
        return {
          name: route.name,
          params: {
            id: this.$route.params[route.key],
          },
        };
      }

      return {
        name: route.name,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.tabs {
  .v-tabs-bar__content {
    min-width: 120px !important;
  }
}
</style>
